import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Alert, Spinner } from 'react-bootstrap';

/**
 * Modal para actualizar precios de productos (precio único).
 */
function ModalActualizarPrecios({
  show,
  onHide,
  productos,
  preciosUniforme,
  onActualizar,
  updating,
  error,
}) {
  const [precio, setPrecio] = useState('');

  useEffect(() => {
    if (show) {
      setPrecio(preciosUniforme?.precio != null ? String(preciosUniforme.precio) : '');
    }
  }, [show, preciosUniforme]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const valor = precio === '' ? '' : Number(precio);
    onActualizar({
      precio: valor,
    });
  };

  const canSubmit = precio !== '' && Number(precio) >= 0;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Actualizar precios</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          {preciosUniforme ? (
            <Alert variant="info" className="mb-3">
              Los productos filtrados tienen el mismo precio. Podés actualizarlos todos a la vez.
            </Alert>
          ) : (
            <Alert variant="warning" className="mb-3">
              Los productos filtrados tienen precios distintos. El nuevo precio se aplicará a todos.
            </Alert>
          )}
          <p className="mb-3">
            Se actualizarán <strong>{productos.length}</strong> producto
            {productos.length !== 1 ? 's' : ''}.
          </p>
          <Form.Group className="mb-3">
            <Form.Label>Precio</Form.Label>
            <Form.Control
              type="number"
              value={precio}
              onChange={(e) => setPrecio(e.target.value)}
              placeholder="0"
              step="0.01"
              min="0"
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={updating}>
            Cancelar
          </Button>
          <Button variant="primary" type="submit" disabled={updating || !canSubmit}>
            {updating ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Actualizando...
              </>
            ) : (
              'Actualizar precios'
            )}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default ModalActualizarPrecios;
